import React, { Component } from 'react';
import './Header.css';
import Logo from './img/watchdog.png';
import Onsophic from './img/onsophic.png';
// eslint-disable-next-line
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher.jsx';
import { Button } from 'react-bootstrap';
import MonitorApi from '../../utils/MonitorApi';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.locales =  ['en','nl'];
    this.isAuthorized = MonitorApi.isAuthorized();
  }
  logout(){
    MonitorApi.logout();
  }
  render() {
    return (
      <nav className="navbar">
        <div className="col-xs-4 nav_item verticalCenter">
          <div>
            <div className="header_circle_img centerAll">
              <img  role="presentation" src={Logo} className="header_img" />
            </div>
          </div>
        </div>
        <div className="col-xs-4 nav_item centerAll header_img_title">
          <img  role="presentation" src={Onsophic} className="onsophic_img" />
          <h3>Status</h3>
        </div>
        {
          this.isAuthorized ?
            <div className="col-xs-4 nav_item verticalCenter horizontalRight">
              <Button onClick={this.logout}
                      type="button"
                      className="logout no_style">
                <span className="logout_icon icon-unlock"></span>
              </Button>
            </div>
            : undefined
        }

      </nav>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.jsx
 **/